import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useCartao } from "../../hooks/cartao";
import { cartoes } from "../../services/cartao";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { AiFillWarning } from "react-icons/ai";
import IconCard from "../../images/credit-card.svg";
import { TailSpin } from "react-loading-icons";
import { IoIosArrowDroprightCircle } from "react-icons/io";

const FormCartao: React.FC = (props) => {
    const queryParams = new URLSearchParams(window.location.search);
    const cpf_cartao = queryParams.get("cpf_cartao");

    useEffect(() => {
        if (cpf_cartao) {
            handleSubmit(cpf_cartao);
        }
    }, [cpf_cartao]);

    const {
        passo,
        erro,
        alteraPasso,
        alteraErro,
        alteraQtCartoes,
        alteraDadosCartoes,
        alteraCartaoCpf,
    } = useCartao();

    const validationSchema = Yup.object().shape({
        cpf_cartao: Yup.string()
            .min(11, "Quantidade de digitios inválidos")
            .max(21, "Quantidade de digitios inválidos")
            .required("Digite o CPF ou o número do cartão"),
    });

    const handleSubmit = async (cpfCartao: string) => {
        let post = {};

        if (cpfCartao.length <= 14) {
            post = { cpf: cpfCartao };
        } else {
            post = { cartao: cpfCartao };
        }

        const returnCartoes = await cartoes(post);

        if (returnCartoes.error) {
            alteraPasso(0);
            alteraErro(returnCartoes.msg);
        } else {
            alteraCartaoCpf(cpfCartao);
            alteraQtCartoes(returnCartoes.qt);
            alteraDadosCartoes(returnCartoes.cartoes);
            if (returnCartoes.qt !== 0) {
                alteraPasso(1);
            } else {
                alteraErro(
                    "Nenhum cadastro encontrado com o dado informado ou você não possui cartões bloqueados"
                );
            }
        }
    };

    return (
        <>
            {passo === 0 && (
                <Formik
                    initialValues={{
                        cpf_cartao: "",
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        alteraErro(null);
                        await handleSubmit(values.cpf_cartao);
                        setSubmitting(false);
                    }}
                    validationSchema={validationSchema}
                >
                    {({ errors, touched, isSubmitting }: any) => (
                        <Form className="w-full">
                            {erro !== "" &&
                                erro !== null &&
                                typeof erro === "string" && (
                                    <div className="w-full mx-auto  my-4 ">
                                        <div className="flex items-center justify-between px-6 py-2 mx-6 bg-red-600 text-white border border-red-500 rounded-lg shadow-xl">
                                            <div className="flex">
                                                <AiFillWarning />
                                                <p className="text-sm font-semibold tracking-wide uppercase ">
                                                    {erro}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            <div className="flex flex-shrink-0 justify-between w-full gap-2 items-center lg:justify-start bg-white py-0 h-10 lg:h-16 rounded-2xl shadow-md">
                                <div className="px-2 my-2">
                                    <img
                                        src={IconCard}
                                        className="h-20 opacity-40 hidden lg:block"
                                        alt="Digite o CPF ou o número do cartão"
                                    />
                                </div>
                                <div className="h-full py-2 w-px hidden lg:block">
                                    <div className="h-full w-full bg-gray-300"></div>
                                </div>
                                <Field
                                    id="cpf_cartao"
                                    name="cpf_cartao"
                                    placeholder="Digite o CPF ou o nº do cartão"
                                    className="flex-grow w-full h-full px-4 py-0 text-base text-black transition ease-in-out transform rounded-lg  duration-650 lg:w-auto bg-blueGray-200 focus:outline-none focus:border-0 sm:mb-0 focus:bg-white focus:shadow-outline focus:ring-0"
                                />
                                <button
                                    disabled={isSubmitting}
                                    type="submit"
                                    className="hidden lg:flex items-center h-full px-2 lg:px-6 py-3 mt-auto font-light text-lg text-white transition duration-500 ease-in-out transform bg-gradient-to-r from-red-900 to-theme rounded-lg  hover:bg-opacity-90 focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-2"
                                >
                                    {isSubmitting && (
                                        <TailSpin
                                            className="h-8 px-2"
                                            speed="1"
                                        />
                                    )}
                                    Desbloquear
                                </button>
                                <button
                                    disabled={isSubmitting}
                                    type="submit"
                                    className="lg:hidden flex items-center h-full px-4 py-3 mt-auto font-light text-lg text-white transition duration-500 ease-in-out transform bg-gradient-to-r from-red-900 to-theme rounded-lg  hover:bg-opacity-90 focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-2"
                                >
                                    {isSubmitting && (
                                        <TailSpin
                                            className="h-8 px-2"
                                            speed="1"
                                        />
                                    )}
                                    <IoIosArrowDroprightCircle />
                                </button>
                            </div>
                            {errors.cpf_cartao && touched.cpf_cartao ? (
                                <div className="flex items-center text-red-600 py-2">
                                    <AiFillWarning></AiFillWarning>
                                    <p className="px-2">{errors.cpf_cartao}</p>
                                </div>
                            ) : null}
                        </Form>
                    )}
                </Formik>
            )}
        </>
    );
};

export default FormCartao;
